import cn from 'classnames'
import { TPartnerStatus } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { PartnerStatusIcon } from './components/partnerStatusIcon/PartnerStatusIcon'
import { PartnerStatusLabel } from './components/partnerStatusLabel/PartnerStatusLabel'
import { isPartnerStatusIcon } from './helpers/typeGuards'

import styles from './PartnerFlags.module.scss'

interface IPartnerFlagsProps {
  labelTranslationKey?: string
  emptyItemsTranslationKey?: string
  items?: TPartnerStatus[]
  classes?: {
    partnerStatusStyles?: string
    flagsList?: string
  }
}

export const PartnerFlags: FC<IPartnerFlagsProps> = ({
  labelTranslationKey,
  emptyItemsTranslationKey,
  items,
  classes,
}) => {
  const partnerStatuses = useMemo(() => {
    if (!items || items.length === 0) {
      return (
        <div className={styles.emptyTranslationMessage}>
          {emptyItemsTranslationKey ? (
            <Translation text={emptyItemsTranslationKey} span htmlAvailable />
          ) : null}
        </div>
      )
    }

    return items.map((profile, idx) => {
      if (isPartnerStatusIcon(profile)) {
        return (
          <PartnerStatusIcon
            className={classes?.partnerStatusStyles}
            key={`${profile}:${idx}`}
            profile={profile}
          />
        )
      }

      return (
        <PartnerStatusLabel
          className={classes?.partnerStatusStyles}
          key={`${profile}:${idx}`}
          profile={profile}
        />
      )
    })
  }, [items, emptyItemsTranslationKey, classes?.partnerStatusStyles])

  return (
    <div>
      {labelTranslationKey ? <FieldLabel labelTranslation={labelTranslationKey} /> : null}
      <div className={cn(styles.programsList, classes?.flagsList)}>{partnerStatuses}</div>
    </div>
  )
}
